import { selectProgramType } from 'legacy/lut/features/partner360/configuration'
import { useUserRoles } from 'legacy/lut/hooks/useUserRoles'
import { getIsAccessDenied } from 'legacy/lut/selectors/app'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectCurrentSitePageId } from 'core-components/sitebuilder/store/selectors/selectCurrentSitePageId'

export const useP360Access = () => {
  const { isPartnerUser } = useUserRoles()
  const isAccessDenied = useSelector(getIsAccessDenied)
  const programType = useSelector(selectProgramType)
  const currentSitePageId = useSelector(selectCurrentSitePageId)

  const isP360Page = useMemo(() => {
    return currentSitePageId === 'p360'
  }, [currentSitePageId])

  const isAccessDeniedBecauseIsRetail = useMemo(() => {
    return isPartnerUser && isP360Page && programType === 'Retail'
  }, [isP360Page, isPartnerUser, programType])

  return {
    isAccessDeniedUAM: isAccessDenied,
    isAccessDeniedRetail: isAccessDeniedBecauseIsRetail,
    isAccessDenied: isAccessDenied || isAccessDeniedBecauseIsRetail,
  }
}
